import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { BrandConfig } from './types'

const initialState: BrandConfig = {
  categoriesWith3DImage: {},
  wheelOfWinners: null,
  wheelCard: null,
  wheelConfigName: null,
  promoWheel: null,
  loyaltyConfig: null,
  dailyRewardDialog: null,
  widgetsBar: null,
}

export const brandConfigSlice = createSlice({
  name: 'brandConfig',
  initialState,
  reducers: {
    saveBrandConfig: (state, action: PayloadAction<BrandConfig>) => {
      state.categoriesWith3DImage = action.payload.categoriesWith3DImage
      state.wheelOfWinners = action.payload.wheelOfWinners
      state.wheelCard = action.payload.wheelCard
      state.wheelConfigName = action.payload.wheelConfigName
      state.promoWheel = action.payload.promoWheel
      state.loyaltyConfig = action.payload.loyaltyConfig
      state.dailyRewardDialog = action.payload.dailyRewardDialog
      state.widgetsBar = action.payload.widgetsBar
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof brandConfigSlice.actions>>

export const { actions } = brandConfigSlice
